import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '../../Assets/svg/CheckIcon';
import './CustomCheckboxDiv.css';

const CustomCheckboxDiv = ({
  checked,
  onChange,
  label,
  id,
  disabled = false,
  className = '',
  ...props
}) => {
  // Keyboard accessibility: toggle on space/enter
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange && onChange(e);
    }
  };

  return (
    <div
      id={id}
      className={`custom-checkbox-div-label ${className} ${disabled ? 'disabled' : ''}`}
      role="checkbox"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onChange}
      onKeyDown={handleKeyDown}
      aria-disabled={disabled}
      {...props}
    >
      <div className={`custom-checkbox-div-box ${checked ? 'checked' : ''}`}>{checked && <CheckIcon />}</div>
      {label && <span className="custom-checkbox-div-text">{label}</span>}
    </div>
  );
};

CustomCheckboxDiv.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  id: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CustomCheckboxDiv;
